import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { PackCrudService } from 'src/app/shared/services/pack-crud.service';
import { Pack } from 'src/app/shared/interfaces/pack';
import { Harvest } from '../shared/interfaces/harvest';
import { HarvestCrudService } from '../shared/services/harvest-crud.service';

@Component({
  selector: 'app-packings',
  templateUrl: './packings.component.html',
  styleUrls: ['./packings.component.scss']
})
export class PackingsComponent implements OnInit {

  packs: Pack[];
  pack: Pack;
  selectedPacks: Pack[] = [];

  harvests: Partial<Harvest>[];
  harvestNames: string[];
  harvestsMap : Map<string,Harvest>;


  packDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private packService : PackCrudService,
    private harvestService : HarvestCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Packs'}
    ];

    this.packs = [];
    this.pack = { } as Pack ;

    this.harvests = [];
    this.harvestNames = [];
    this.harvestsMap = new Map<string,Harvest>();
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.packService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.packs = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Pack = jsonItem as Pack;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.packs.push(l);
        }
      })
    });

    let h = this.harvestService.getList(); 
    h.snapshotChanges().subscribe(data => {
      this.harvests = [];
      this.harvestNames = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Harvest = jsonItem as Harvest;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          //l.code = l.name;
          let ll : Partial<Harvest> = l;
          delete ll.$key;
         // if (l.isEnabled ) {
            this.harvests.push(ll);
            this.harvestNames.push(l.name);
         // }
          this.harvestsMap.set(l.key || 'na' , l);
        }
      });
     // console.log(this.grapeVarieties);
     this.harvests = this.harvests.sort((a, b) => ( (a.position || 0) < (b.position || 1) ) ? -1 : 1);
    });

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Notes' },
      { field: 'tags', header: 'Tags' },

     // { field: 'packedOrderKey', header: 'Harvest' },
      { field: 'packedOrderName', header: 'Order' },
      { field: 'packedAt', header: 'At' },
      { field: 'packedBy', header: 'By' },
      { field: 'itemTypeName', header: 'Content' },
      { field: 'itemNumber', header: 'Number' },

      // { field: 'harvestName', header: 'Harvest' },
      // { field: 'fishAverageWeight', header: 'Weight (avg)' },
      // { field: 'fishNumber', header: 'Fish (nb)' },
      // { field: 'fishMortality', header: 'Mortality (nb / %)' },
      // { field: 'filledAt', header: 'Filled at' },
      // { field: 'emptiedAt', header: 'Emptied at' },

      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'tags');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.packService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.packs);
            doc.save('packs.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.packs);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "packs");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedPacks);
      // console.log('SAVEC CSV LOCATIONS ', this.packs);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedPacks, 'packs', exportCols);
   // this.exportService.exportToCsv(this.packs, 'packs', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.pack = {} as Pack;
    this.submitted = false;
    this.packDialog = true;
  }

  deleteSelectedPacks() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected packs?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.packs = this.packs.filter(val => !this.selectedPacks.includes(val));
            
            this.selectedPacks.forEach( pack => this.packService.delete(pack.$key));
            this.selectedPacks = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Packss Deleted', life: 3000});
        }
    });
  }

  editPack(pack: Pack) {
    this.pack = {...pack};
    this.packDialog = true;
  }

  deletePack(pack: Pack) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + pack.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.packs = this.packs.filter(val => val.$key !== pack.$key);
            this.pack = {} as Pack;
            this.packService.delete(pack.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Pack Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.packDialog = false;
    this.submitted = false;
  }

  savePack() {
    this.submitted = true;

    if ( this.pack.name.trim() ) {
      if (this.pack.$key) {
          this.packs[this.findIndexById(this.pack.$key)] = this.pack;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Pack Updated', life: 3000});
          this.packService.update(this.pack);
        } else {
          this.pack.position = this.packs.length;
          this.packService.add(this.pack);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Pack Created', life: 3000});
      this.packs = [...this.packs];
    }

    this.packDialog = false;
    this.pack = { } as Pack;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.packs.length; i++) {
        if (this.packs[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completePack(pack : Pack) {
    this.packService.update(pack);
  }

  completePosition(pack : Pack) {
    if ( this.newPosition > -1 ) {
        pack.position = this.newPosition;
        pack = this.checkPositionLimits(pack);
        this.reorderElements(pack);
        //this.updateDB(pack);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.packs);
    // const myClonedArray = [];
    // this.packs.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.packs.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.packs.length - 1 - event.dropIndex;
    const packToMove = this.packs[startIndex];

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.packs[index] = this.packs[index+1];
        this.packs[index].position = index;
        this.packService.update(this.packs[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.packs[index] = this.packs[index-1];
        this.packs[index].position = index;
        this.packService.update(this.packs[index]);
      }
    } 
    this.packs[endIndex] = packToMove;
    this.packs[endIndex].position = endIndex;
    this.packService.update(this.packs[endIndex]);
  }

  // onFieldEdit(pack: Spray, fieldName: string): void {
  //   //console.log(this.packs);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + pack[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       pack.position = this.newPosition;
  //       pack = this.checkPositionLimits(pack);
  //       this.reorderElements(pack);
  //       //this.updateDB(pack);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(pack);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.packs.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, pack: Pack) {
    // console.log("event" +event);
    if (pack.position != null && pack.position > -1) {
      this.previousPosition = pack.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(pack: Pack) {
    console.log('check ',pack.position + ' ' + this.packs.length);
    if (!pack.position) {
     // console.log('check 1');
      return this.pack;
    }
    if (pack.position < 0) {
      pack.position = 0;
      // console.log('check 2');
      return pack;
    }
    if (pack.position > this.packs.length) {
      pack.position = this.packs.length - 1;
    //  console.log('check 3', pack.position);
      return pack;
    }
   // console.log('check 4');
    return pack;
  }

  async reorderElements(pack: Pack) {
    this.newPosition = this.newPosition  > this.packs.length ? this.packs.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === pack.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const packToMove = this.packs[startIndex];
   // console.log('Item to move: ', this.packs[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.packs);
        console.log('Item to +1: ', this.packs[index+1]);

        this.packs[index] = this.packs[index+1];
        this.packs[index].position = index;
        // console.log('Move: ', this.packs[index+1]);
        // console.log('Move pos: ', this.packs[index].position);
        //await this.updateDB(this.packs[index]);
        this.packService.update(this.packs[index]);
     //   console.log('Update DB: ', this.packs[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.packs[index] = this.packs[index-1];
        this.packs[index].position = index;
        this.packService.update(this.packs[index]);
      }
    } 
    this.packs[endIndex] = packToMove;
    this.packs[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.packService.update(this.packs[endIndex]);
    
    // const myClonedArray = [];
    // this.packs.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.packs = myClonedArray;
   // this.getAllRecords();
  }


  onSelect (event: any, pack: Pack) {
    //this.completeBarrel(barrel);
  }

  onBlur(event: any, pack: Pack) {
    this.completePack(pack);
  }

  onClose(event: any, pack: Pack) {
    this.completePack(pack);
  }


  onChangeHarvest(pack: Pack, packHarvestKey: string, event: any): boolean {

    // console.log('barrel event', event);
    // console.log('be ', event);

    const newKey = event.value;
    const previousKey = packHarvestKey;
    console.log('new key wanted',  newKey);
    console.log('before key ', previousKey);

    // Si il n'y en avait pas avant et ni maintenant, riemn a faire
    if (!previousKey && !newKey) {
      return true;
    }

    // Si le barril est le meme rien a faire
    if (previousKey && newKey && previousKey == newKey) {
      return true;
    }


    // Sil il n'y avait pas de barril avant et maintenant oui
    // if (!previousKey && newKey) {

    //   const newHarvest = this.harvestsMap.get(newKey) || {} as Harvest;
    //   const newHarvestName = newHarvest.name;
        
    //   pack.harvestKey = newKey;
    //   pack.harvestName = newHarvestName;
    //   this.packService.update(pack);
    //   return true;

    // }

    // if (previousKey && !newKey) {
    //   pack.harvestKey = '';
    //   pack.harvestName = '';
    //   this.packService.update(pack);
    //   return true;
    // }

    // const newRegion = this.harvestsMap.get(newKey) || {} as Harvest;
    // const newHarvestName = newRegion.name;
        
    // pack.harvestKey = newKey;
    // pack.harvestName = newHarvestName;
    this.packService.update(pack);
    return true;
  }

  displayHarvestName(key : string): string {
    if (this.harvestsMap.has(key)) {
      return this.harvestsMap.get(key)?.name || '';
    }
    return '';
  }

}
